import script from "./ListAgents.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListAgents.vue?vue&type=script&lang=ts&setup=true"

import "./ListAgents.vue?vue&type=style&index=0&id=475b19ac&lang=css"

export default script